import type { FC } from "react";

import { Menu, MenuItem } from "@jti/core-components";
import type { Language } from "@jti/fe-common";

import styles from "./LanguageSelectorPopupDesktop.module.scss";

type LanguageSelectorPopupDesktopProps = {
  languages: Language[];
  isOpened: boolean;
  onSelectLanguage: (language: Language) => void;
};

export const LanguageSelectorPopupDesktop: FC<LanguageSelectorPopupDesktopProps> = ({
  languages,
  isOpened,
  onSelectLanguage,
}) => {
  if (!isOpened) {
    return null;
  }
  return (
    <Menu data-testid="languageSelectorPopupDesktop" className={styles.container}>
      {languages.map((language) => (
        <MenuItem
          key={language.associatedCookieValue}
          label={language.languageDisplayName}
          isSelected={language.current}
          onClick={() => onSelectLanguage(language)}
          data-testid="languageSelectorLangBtn"
        />
      ))}
    </Menu>
  );
};
